<div class="livefeed-container" #scrollContainer (scroll)="onScroll()">
  <div class="stats-bar">
    <div class="stats-left">
      <span class="stat-item">
        <span class="stat-count">{{ livefeedService.stats().total | number }}</span> events
      </span>
      <span class="stat-item stat-new">
        <span class="stat-count">{{ livefeedService.stats().new | number }}</span> new
      </span>
      <span class="stat-item stat-price-change">
        <span class="stat-count">{{ livefeedService.stats().price_change | number }}</span> price changes
      </span>
      @if (livefeedService.eventsPerMin() > 0) {
        <span class="stat-item stat-rate">
          <span class="stat-count">{{ livefeedService.eventsPerMin() }}</span>/min
        </span>
      }
    </div>
    <div class="stats-right">
      <span class="connection-indicator" [class.connected]="livefeedService.isConnected()">
        {{ livefeedService.isConnected() ? 'Live' : 'Disconnected' }}
      </span>
      <button mat-flat-button color="accent" class="pause-button" (click)="livefeedService.togglePause()">
        <mat-icon>{{ livefeedService.isPaused() ? 'play_arrow' : 'pause' }}</mat-icon>
        {{ livefeedService.isPaused() ? 'Resume' : 'Pause' }}
      </button>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-toggle-row">
      <button class="filter-toggle" (click)="filtersExpanded.set(!filtersExpanded())"
              [class.active]="hasActiveFilters()">
        <mat-icon>filter_list</mat-icon>
        Filters
        @if (hasActiveFilters()) {
          <span class="filter-dot"></span>
        }
      </button>
      <div class="filter-search">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" placeholder="Search titles..." [ngModel]="searchText()"
               (ngModelChange)="searchText.set($event)" />
      </div>
      @if (hasActiveFilters()) {
        <button class="filter-clear" (click)="clearFilters()">Clear</button>
      }
    </div>
    @if (filtersExpanded()) {
      <div class="filter-options">
        <div class="filter-group">
          <span class="filter-label">Type</span>
          <div class="type-chips">
            @for (opt of FILTER_OPTIONS; track opt.key) {
              <button class="type-chip" [class.active]="filterTypes().has(opt.key)"
                      [attr.data-type]="opt.key" (click)="toggleFilterType(opt.key)">
                {{ opt.label }}
              </button>
            }
          </div>
        </div>
        <div class="filter-group">
          <span class="filter-label">Category</span>
          <select [ngModel]="selectedCategory()" (ngModelChange)="selectedCategory.set($event)">
            <option value="">All</option>
            @for (cat of categoryOptions; track cat.rootcat) {
              <option [value]="cat.name">{{ cat.name }}</option>
            }
          </select>
        </div>
        <div class="filter-group">
          <span class="filter-label">Min savings</span>
          <div class="savings-input">
            <input type="number" min="0" max="99" placeholder="0"
                   [ngModel]="minSavings()" (ngModelChange)="minSavings.set($event || 0)" />
            <span class="savings-suffix">%</span>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="events-list">
    @if (livefeedService.pendingCount() > 0) {
      <button class="new-events-pill" (click)="showNewEvents()">
        <mat-icon>arrow_upward</mat-icon>
        {{ livefeedService.pendingCount() }} new {{ livefeedService.pendingCount() === 1 ? 'event' : 'events' }}
      </button>
    }
    @for (event of filteredEvents(); track trackByEventId($index, event)) {
      <mat-card class="event-card mat-elevation-z2">
        <a class="event-link" target="_blank" [href]="event.amazonlink">
          <div class="event-content">
            <div class="event-image-container">
              @if (event.imagename) {
                <img [src]="event.imagename | amazonImage:128" [alt]="event.title" />
              } @else {
                <mat-icon class="placeholder-icon">image</mat-icon>
              }
            </div>
            <div class="event-details">
              <div class="event-header">
                <span class="event-badge" [attr.data-type]="event.event_type">
                  {{ eventTypeLabel(event.event_type) }}
                </span>
                @if (event.category) {
                  <span class="event-category">{{ event.category }}</span>
                }
                <span class="event-time">{{ event.created_at | timeAgo }}</span>
              </div>
              <p class="event-title">{{ event.title }}</p>
              <div class="event-pricing">
                <span class="event-price">
                  {{ event.displayusedprice | currency: currencyMap[domain] }}
                </span>
                @if (event.displaysavingspercent) {
                  <span class="event-savings">&gt; {{ event.displaysavingspercent }}% off</span>
                }
                @if (event.displaypricedifference) {
                  <span class="event-diff">
                    Save {{ event.displaypricedifference | currency: currencyMap[domain]:'symbol':'1.0-0' }}
                  </span>
                }
                @if (event.event_type === 'price_change' && event.old_usedprice != null) {
                  <span class="event-old-price">
                    was {{ (event.old_usedprice / 100) | currency: currencyMap[domain] }}
                  </span>
                }
              </div>
            </div>
            <div class="event-action">
              <mat-icon>launch</mat-icon>
            </div>
          </div>
        </a>
      </mat-card>
    } @empty {
      <div class="empty-state">
        @if (hasActiveFilters()) {
          <mat-icon class="empty-icon">filter_list_off</mat-icon>
          <p>No events match your filters</p>
        } @else if (livefeedService.isConnected()) {
          <mat-icon class="empty-icon">hourglass_empty</mat-icon>
          <p>Waiting for product updates...</p>
        } @else {
          <mat-icon class="empty-icon">wifi_off</mat-icon>
          <p>Livefeed disconnected</p>
        }
      </div>
    }
  </div>
</div>
